import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useCreateData } from '../../hooks/useApi'
// import the formElement from the zustand
import { useFormPlaygroundStore } from '../../stores/formPlaygroundStore'
import { ScrollArea } from '../ui/scroll-area'

import FormElementCard from './FormElementCard'
import { Button } from '@/components/ui/button'
import { ArrowLeftIcon } from 'lucide-react'

function FormPreview() {
  const params = useParams()
  const navigate = useNavigate()

  const { mutate: getFormById, data: formData, isPending } = useCreateData('/get-form', 'forms')

  const formElements = useFormPlaygroundStore((state) => state.formElements)

  useEffect(() => {
    if (params.id) {
      getFormById({ formId: params.id })
    }
  }, [params.id, getFormById])

  const elementsToRender =
    params.id && formData?.data?.elements?.length ? formData.data.elements : formElements

  if (isPending) {
    return (
      <div className="flex items-center justify-center min-h-screen mt-[-10vh]">
        <div className="animate-spin border-4 border-button-purple border-t-transparent rounded-full w-12 h-12"></div>
      </div>
    )
  }

  return (
    <div>
      {/* Back Button */}
      <Button
        variant="outline"
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 mb-4 cursor-pointer"
      >
        <ArrowLeftIcon className="h-4 w-4" />
        Back
      </Button>

      <section className="flex-grow rounded-lg border-2 border-dashed border-slate-300 bg-muted">
        {elementsToRender.length === 0 ? (
          <p className="flex h-full items-center justify-center font-medium text-muted-foreground">
            Add some form elements in the builder view
          </p>
        ) : (
          <ScrollArea>
            <ul className="space-y-5 p-5">
              {elementsToRender.map((element) => (
                <li key={element.id}>
                  <FormElementCard formElement={element} isView isPreview />
                </li>
              ))}
            </ul>
          </ScrollArea>
        )}
      </section>
    </div>
  )
}

export default FormPreview
